import React from "react";
import "./topUpModal.css";
import Modal from "react-bootstrap/Modal";
import { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Row } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import moment from "moment";
import Select from "react-select";
import {
  getSellers,
  getSellersByCompanyId,
  getSellerWalletDetails,
  UpdateTopUpFundDetails,
} from "../../../store/actions/fundManagement";
import {
  GET_SELLERS,
  GET_WALLET_BALANCE,
} from "../../../store/types";
import { toast } from "react-toastify";
import DatePicker from "react-datepicker";
import PropTypes from "prop-types";

function TopUpModal(props) {
  const { fundList, showModal = true } = props;
  const modalRef = useRef();
  const saveCooldownRef = useRef(null);
  const isSubmittingRef = useRef(false);
  const dispatch = useDispatch();
  const [errors, setErrors] = useState({});
  const [selectedsellerData, setselectedSellerData] = useState();
  const [amount, setAmount] = useState(null);
  const [sellerList, setSellerList] = useState([]);
  const [isSaveDisabled, setIsSaveDisabled] = useState(false);
  const createdBy = useSelector((state) => state?.auth?.user);
  const sellerWalletBalance = useSelector(
    (state) => state?.FundManagementReducer?.getSellerWalletBalance?.EntityList
  );
  const getSellersValue = useSelector(
    (state) => state?.FundManagementReducer?.getSellersDetail?.EntityList
  );
  const [formData, setFormData] = useState({
    createdBy: createdBy?.Value?.employeeId,
    companyId: createdBy?.Value?.companyId,
    sellerId: createdBy?.Value?.sellerId,
    email: createdBy?.Value?.emailId,
    SellerName: {},
    isActive: true,
    id: selectedsellerData?.id,
    amount: 0,
    transactionType: 6,
    topupCompanyId: null,
    shouldSendEmail: true
  });

  useEffect(() => {
    setselectedSellerData('');
  }, [amount]);

  useEffect(() => {
    if (formData?.topupCompanyId?.value) {
      dispatch(getSellers(formData?.topupCompanyId?.Id));
      if (formData?.topupSellerId?.value) {
        dispatch(
          getSellerWalletDetails({
            topupCompanyId: formData?.topupCompanyId?.value,
            topupSellerId: formData?.topupSellerId?.value,
          })
        );
      }
    }
  }, [formData]);

  const TopUpForm = (item, name, sellerDetail) => {
    if (name === "topupCompanyId") {
      setFormData({ ...formData, topupSellerId: null, [name]: item, availableAmount: null });
    } else {
      setFormData({ ...formData, [name]: item });
    }
    setErrors({
      ...errors,
      [name]: "",
    });
  };

  const handleDateChange = (e, name) => {
    setFormData({
      ...formData,
      [name]: moment(e).format("MM-DD-YYYY"),
    });
    setErrors({
      ...errors,
      [name]: "",
    });
  };

  useEffect(() => {
    if (getSellersValue?.length) {
      let data = getSellersValue.map((item) => {
        return {
          label: item.sellerName,
          value: item.sellerId,
        };
      });
      setSellerList(data);
    } else {
      setSellerList([]);
    }
  }, [getSellersValue]);

  useEffect(() => {
    handleCompanySellerDefault();
  }, []);

  useEffect(() => {
    return () => {
      if (saveCooldownRef.current) {
        clearTimeout(saveCooldownRef.current);
      }
    };
  }, []);

  const handleCompanySellerDefault = async () => {
    if (fundList?.length && props.activeSellerList.length) {
      let findChecked = fundList.filter(item => item.isChecked);
      if (findChecked.length) {
        getSellersByCompanyId(findChecked[0].companyId).then((resp) => {
          let data = resp.data.EntityList.map((item) => {
            return {
              label: item.sellerName,
              value: item.sellerId,
            };
          });
          setSellerList(data);
          let findInCompanyList = props.activeSellerList.filter(item => item.Id === findChecked[0].companyId)[0] || []; // NOSONAR
          let findInSellerList = data.filter(item => item.value === findChecked[0].sellerId)[0] || []; // NOSONAR
          setFormData({
            ...formData,
            topupCompanyId: findInCompanyList,
            topupSellerId: findInSellerList
          })
        })
      }
    }
  }

  const releaseSaveLock = (delay = 0) => {
    if (saveCooldownRef.current) {
      clearTimeout(saveCooldownRef.current);
    }

    saveCooldownRef.current = setTimeout(() => {
      isSubmittingRef.current = false;
      setIsSaveDisabled(false);
      saveCooldownRef.current = null;
    }, delay);
  };

  const saveTopUpData = async () => {
    if (isSubmittingRef.current) {
      return;
    }

    if (
      formData?.topupCompanyId?.value &&
      formData?.amount > 0 &&
      formData?.topupSellerId
    ) {
      isSubmittingRef.current = true;
      setIsSaveDisabled(true);
      const submitStartedAt = Date.now();

      const isSuccess = await Promise.resolve(dispatch(UpdateTopUpFundDetails(
        {
          ...formData,
          createdDate: moment(formData?.createdDate).format("MM-DD-YYYY HH:mm:ss"),
          topupCompanyId: formData?.topupCompanyId?.value,
          topupCompayId: formData?.topupCompanyId?.value,
          topupSellerId: formData?.topupSellerId?.value,
          role: createdBy?.Value?.role,
          companySellerId: createdBy?.Value?.companySellerId,
        },
        sellerWalletBalance,
        setAmount,
        createdBy?.Value?.isAdmin,
        props.onHide,
        props.filterData
      )));

      const remainingCooldown = Math.max(0, 5000 - (Date.now() - submitStartedAt));
      releaseSaveLock(remainingCooldown);

      if (isSuccess) {
        toast.success("Recharged Succesfully");
      }
    } 
    if (
      !formData?.topupCompanyId?.value &&
      !formData?.amount >= 0 &&
      !formData?.topupSellerId
    ) {
      setErrors({
        SellerName: "This is a mandatory field",
        amount: "Amount should not be empty or 0",
        topupSellerId: "This is a mandatory field",
      });
    } else if (!formData?.SellerName?.name == {} && formData?.amount >= 0) { // NOSONAR
      setErrors({
        SellerName: "This is a mandatory field",
      });
    } else if (!formData?.amount && !formData?.topupSellerId?.label) {
      setErrors({
        amount: "Amount should not be empty or 0",
        topupSellerId: "This is a mandatory field",
      });
    } else if (!formData?.amount) {
      setErrors({
        amount: "Amount should not be empty or 0",
      });
    } else if (!formData?.topupSellerId?.label) {
      setErrors({
        topupSellerId: "This is a mandatory field",
      });
    }
    
  };

  const handleCancel = () => {
    dispatch({
      type: GET_WALLET_BALANCE,
      payload: [],
    });
    dispatch({
      type: GET_SELLERS,
      payload: [],
    });
    props.onHide();
  };

  return (
    <Modal
      {...props}
      size="lg"
      className="topUpModal"
      centered
      backdrop="static"
      ref={modalRef}
      show={showModal}
    >
      <div className="top_modal_header_container">
        <span className="">Top Up</span>
        <div className="modalDeleteWrapper">
          <button
            type="button"
            onClick={() => handleCancel()}
            className="btn-close"
            aria-label="Close"
          ></button>
        </div>
      </div>
      <div className="modal_container_rate_card">
        <div className="row modal_input">
          <div className="col-lg-4 col-sm-12 mobMb-10 formLabel ">
            <span className="input-label fnt-wgt-editmgmt">Company Name:</span>
          </div>
          <div className="col-lg-8 col-sm-12">
            <div className={"select_react"}>
              <Select
                options={props?.activeSellerList}
                onChange={(value) => TopUpForm(value, "topupCompanyId", "seller")}
                className="activeSellerListInput"
                value={formData.topupCompanyId}
              />
            </div>
            <p className="error dialogError"> {errors?.SellerName}</p>
          </div>
        </div>
        <div className="row modal_input">
          <div className="col-lg-4 col-sm-12 mobMb-10 formLabel ">
            <span className="input-label fnt-wgt-editmgmt">Seller Name:</span>
          </div>
          <div className="col-lg-8 col-sm-12">
            <div className={"select_react"}>
              <Select
                options={sellerList}
                onChange={(value) => TopUpForm(value, "topupSellerId")}
                className="activeSellerListInput"
                isDisabled={!formData?.topupCompanyId?.name}
                value={formData?.topupSellerId}
                classNamePrefix="list-value"

              />
            </div>
            <p className="error dialogError">
              {" "}
              {errors?.topupSellerId}
            </p>
          </div>
        </div>
        <div className="row modal_input">
          <div className="col-lg-4 col-sm-12 mobMb-10 formLabel">
            <span className="input-label fnt-wgt-editmgmt">Available Balance ($):</span>
          </div>
          <div className="col-lg-8 col-sm-12">
            <input
              onChange={(e) => TopUpForm(e, "AvailableBalance")}
              disabled
              value={
                sellerWalletBalance?.length &&
                sellerWalletBalance?.[0]?.availableAmount
              }
              className="form-control availableBalanceInput"
              type="text"
            />
            <p className="error dialogError">{errors.Name}</p>
          </div>
        </div>
        <div className="row modal_input">
          <div className="col-lg-4 col-sm-12 mobMb-10 formLabel">
            <span className="input-label fnt-wgt-editmgmt">Transaction Date:</span>
          </div>
          <div className="col-lg-8 col-sm-12">
            <DatePicker
              data-testid={'createdDate'}
              className="form-control createdDate"
              showIcon
              dateFormat="MM-dd-yyyy"
              name="createdDate"
              onChange={(e) => handleDateChange(e, "createdDate")}
              value={formData?.createdDate || moment(new Date()).format("MM-DD-YYYY")}
            />
            <p className="error dialogError">{errors.createdDate}</p>
          </div>
        </div>
        <div className="row modal_input">
          <div className="col-lg-4 col-sm-12 mobMb-10 formLabel">
            <span className="input-label fnt-wgt-editmgmt">Enter The Amount ($):</span>
          </div>
          <div className="col-lg-8 col-sm-12">
            <input
              onChange={(e) => TopUpForm(e.target.value, "amount")}
              className="form-control amountInput"
              min={1}
              onKeyDown={(event) => {
                if (event.key === "-") {
                  event.preventDefault(); // Prevents typing the minus sign
                }
              }}
              type="number"
            />
            <p className="error dialogError">{errors.amount}</p>
          </div>
        </div>
        <div className="row modal_input">
          <div className="col-lg-4 col-sm-12 mobMb-10 formLabel">
            <span className="input-label fnt-wgt-editmgmt">Description:</span>
          </div>
          <div className="col-lg-8 col-sm-12">
            <textarea
              maxLength={100}
              onChange={(e) => TopUpForm(e.target.value, "description")}
              className="form-control amountInput text-area"
              type="text"
              rows={3}
            />
          </div>
        </div>
        <div className="row modal_input fontFix">
          <div className="col-lg-4 col-sm-12 mobMb-10 formLabel"></div>
          <div className="col-lg-8 col-sm-12">
            <input className="sendNotification" type="checkbox" checked={formData.shouldSendEmail} onChange={(e) => setFormData({ ...formData, shouldSendEmail: e.target.checked })} /> Send Notification Email
          </div>
        </div>
        <Row className="modaL_footer">
          <div
            className="col-12 noPadding"
            style={{ textAlign: "right" }}
            xs={12} // NOSONAR
          >
            <Button
              className="btn cus-seconday-bg-btn"
              onClick={() => handleCancel()}
            >
              Cancel
            </Button>
            <Button
              id="saveTopUpBtn"
              className="btn cus-seconday-bg-btn marginLeft5"
              disabled={isSaveDisabled}
              onClick={(e) => {
                saveTopUpData();
              }}
            >
              Add
            </Button>
          </div>
        </Row>
      </div>
    </Modal>
  );
}

TopUpModal.propTypes = {
  fundList: PropTypes.array.isRequired,
  showModal: PropTypes.bool,
  activeSellerList: PropTypes.array.isRequired,
  onHide: PropTypes.func.isRequired,
  filterData: PropTypes.func.isRequired
};

export default TopUpModal;
